import { render, staticRenderFns } from "./deliveryPosition.vue?vue&type=template&id=3008ae61&scoped=true"
import script from "./deliveryPosition.vue?vue&type=script&lang=js"
export * from "./deliveryPosition.vue?vue&type=script&lang=js"
import style0 from "./deliveryPosition.vue?vue&type=style&index=0&id=3008ae61&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008ae61",
  null
  
)

export default component.exports